<template>
  <!-- Version Update Layout - Full screen minimal layout similar to AuthLogin -->
  <div class="version-update-layout">
    <v-container class="fill-height py-8" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <div class="v-responsive" style="max-width: 700px">
            <div class="v-responsive__content">
              <div class="text-overline secondary--text mb-3">Mira One</div>
            </div>
          </div>
          <v-card max-width="600px" class="pa-4">
            <v-card-text>
              <h6 class="text-h6 mb-4">Neue Version verfügbar</h6>
              <p class="text-body-1 mb-4">
                Eine neue Version der App ist verfügbar. Bitte laden Sie die
                Seite neu, um Konflikte zu vermeiden.
              </p>

              <div class="version-info mb-6">
                <div class="text-subtitle-2 mb-2">
                  <strong>Aktuelle Version:</strong>
                  <span class="ml-2">{{ currentVersion }}</span>
                </div>
                <div class="text-subtitle-2 mb-2">
                  <strong>Erforderliche Version:</strong>
                  <span class="ml-2">{{ minimumVersion }}</span>
                </div>
              </div>

              <v-btn
                color="red darken-1"
                block
                x-large
                depressed
                @click="handleReload"
                class="white--text mb-4"
              >
                Seite neu laden
              </v-btn>

              <div v-if="!forceUpdate && supportMode" class="text-center">
                <v-btn plain small class="uppercase" @click="handleBypass">
                  Überspringen (Support)
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- Footer always visible -->
    <div id="footer">
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import { enableSupportBypass } from "@/util/versionCheck";
import Footer from "@/components/_system/main/Footer.vue";

export default {
  name: "version-update-layout",
  components: {
    Footer,
  },
  props: {
    currentVersion: {
      type: String,
      required: true,
    },
    minimumVersion: {
      type: String,
      required: true,
    },
    forceUpdate: {
      type: Boolean,
      default: false,
    },
    supportKeyboardActivated: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    supportMode() {
      try {
        // Only authenticated support users can bypass version checks
        // Add null checks to prevent errors during initial load
        const isOrgSupport =
          this.$store.getters["organization/checkIfSupport"] || false;
        const isUserSupport =
          this.$store.getters["user/checkIfSupport"] || false;
        const isSupport = isOrgSupport || isUserSupport;

        const hasUrlParam = this.$route.query.support === "true";
        const hasKeyboardShortcut = this.supportKeyboardActivated;

        // Require both support user status AND one of the activation methods
        return isSupport && (hasUrlParam || hasKeyboardShortcut);
      } catch (error) {
        console.warn("Error checking support mode:", error);
        return false;
      }
    },
  },
  data() {
    return {};
  },
  mounted() {
    // Prevent scrolling of underlying content
    document.body.classList.add("version-update-active");
  },
  beforeDestroy() {
    // Ensure body class is removed when component is destroyed
    document.body.classList.remove("version-update-active");
  },
  methods: {
    handleReload() {
      // Clear cache and reload
      if ("caches" in window) {
        caches.keys().then((names) => {
          names.forEach((name) => {
            caches.delete(name);
          });
        });
      }
      window.location.reload();
    },
    handleBypass() {
      enableSupportBypass();
      // Emit event to parent to switch back to normal layout
      this.$emit("bypass-activated");
    },
  },
};
</script>

<style scoped>
.version-update-layout {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999; /* Above everything, including app bar */
  background-color: var(--v-background-base, #f6f7f9);
  display: flex;
  flex-direction: column;
}

/* Dark theme background */
.theme--dark .version-update-layout {
  background-color: #121212;
}

/* Ensure footer stays at bottom */
#footer {
  margin-top: auto;
}

/* Prevent scrolling of underlying content */
body.version-update-active {
  overflow: hidden;
}

/* Simple fade-in animation */
.version-update-layout {
  animation: fadeIn 0.2s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
